import { Typography } from '@mui/material'
import React, { useMemo } from 'react'

import { RMLineChart } from 'components/reports/RMLineChart'
import theme from 'theme'
import { ReliabilityReportTrendData } from 'types/api/policies/reliability-report'

export const DashboardReliabilityTrendChart: React.FC<{
  companyReliabilityReportTrend: ReliabilityReportTrendData
}> = ({ companyReliabilityReportTrend }) => {
  const chartData = useMemo(() => {
    if (companyReliabilityReportTrend?.statsByDate) {
      return companyReliabilityReportTrend.statsByDate
        .map((stats) => ({
          date: new Date(stats.trackingDate),
          score: stats.score
        }))
        .reverse()
    }

    return []
  }, [companyReliabilityReportTrend])

  return (
    <>
      <Typography data-test-company-dashboard-trend-chart-title variant="h6">
        Average Company Reliability Score
      </Typography>
      {chartData.length > 0 && (
        <RMLineChart
          data-test-company-dashboard-trend-chart
          css={{
            marginTop: theme.space[1],
            marginLeft: theme.space[2],
            marginRight: theme.space[2]
          }}
          data={chartData}
          dataSeries={['score']}
          domain={{ y: [0, 100] }}
          hasColorBandBackground={true}
          lineColor={theme.colors.steel[1]}
          numOfColumns={0}
          xKey="date"
          yKey="score"
        />
      )}
    </>
  )
}
